export const API_BASE_URL = "https://fulupostore.tsitcloud.com";
